var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", {
    ref: _vm.modalId,
    attrs: {
      id: _vm.modalId,
      title: _vm.modalTitle,
      "ok-title": _vm.modalOkTitle,
      "ok-only": "",
      "data-cy": "save",
      size: _vm.modalSize
    },
    on: { ok: _vm.handleOk },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("rs-document-manager", {
              attrs: {
                "add-file": _vm.addFile,
                files: _vm.files,
                "show-principal-button": _vm.showPrincipalButton,
                "max-files": _vm.maxFiles,
                "required-file-type": _vm.requiredFileType,
                "accepted-file-extensions": _vm.acceptedFileExtensions,
                "required-approval-state": _vm.requiredApprovalState
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }